module.exports = __webpack_public_path__ + "static/media/sub_solution.e3b8f9cf.jpg";